import * as React from 'react';
import './styles.sass';

export interface ISessionSignupButtonProps {
  endInterview: () => void;
}

export const SessionSignupButton: React.StatelessComponent<ISessionSignupButtonProps>
  = ({endInterview}: ISessionSignupButtonProps) => (
    <button
      className={'btn btn_violet session-signup-button'}
      onClick={endInterview}
    >
      <span className={'btn__label'}>Ready? Sign Up Now!</span>
    </button>
  );
